module.exports = __webpack_public_path__ + "static/img/Jake_Lloyd_mobile.b78144a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake_Lloyd_mobile.jpg
// module id = 7Ba+
// module chunks = 0